import { useEffect, useState } from "react";

interface UseAnswerParams {
  answered: boolean | null;
  likes: number;
  dislikes: number;
}

export const useAnswer = ({ answered, likes, dislikes }: UseAnswerParams) => {

  const token = localStorage.getItem('token');

  const [feedback, setFeedback] = useState({ answered, likes, dislikes });

  // Re-sync with authoritative server data when it changes (RTK refetch /
  // pull-to-refresh); otherwise the optimistic local counts would stay frozen.
  useEffect(() => {
    setFeedback({ answered, likes, dislikes });
  }, [answered, likes, dislikes]);

  const handleLike = () => {
    if (!token) return;
    setFeedback(curr => {
      return {
        answered: (curr.answered === null || curr.answered === false) ? true : null,
        likes: curr.answered === true ? curr.likes - 1 : curr.likes + 1,
        dislikes: curr.answered === false ? curr.dislikes - 1 : curr.dislikes,
      };
    });
  };

  const handleDisike = () => {
    if (!token) return;
    setFeedback(curr => {
      return {
        answered: (curr.answered === null || curr.answered === true) ? false : null,
        likes: curr.answered === true ? curr.likes - 1 : curr.likes,
        dislikes: curr.answered === false ? curr.dislikes - 1 : curr.dislikes + 1,
      };
    });
  };

  return {
    feedback,
    handleLike,
    handleDisike,
  };
};
